import toast from "react-hot-toast";
import axios, { AxiosError } from "axios";

function isOkMessage(value: unknown): boolean {
  if (typeof value === "string") return /^ok\.?$/i.test(value.trim());
  if (Array.isArray(value)) {
    return value.length === 1 && isOkMessage(value[0]);
  }
  return false;
}

export const toastError = (error: Error | AxiosError) => {
  if (axios.isAxiosError(error)) {
    const err: AxiosError = error;
    if (err.response && err.response.data.messages) {
      err.response.data.messages.map((e: string) => {
        return toast.error(e);
      });
    } else if (err.response && err.response.data.message) {
      const msg = err.response.data.message;
      if (isOkMessage(msg)) {
        toast.success("Done");
        return;
      }
      toast.error(msg);
    } else toast.error("Something went wrong");
  } else {
    toast.error("Something went wrong");
  }
};

export const toastMessage = (status: "error" | "success", data?: any) => {
  // Express `res.sendStatus(200)` responds with plain text "OK".
  // That string must never show as an error toast (red cross).
  if (isOkMessage(data) || isOkMessage(data?.message)) {
    toast.success("Done");
    return;
  }
  if (Array.isArray(data?.messages) && data.messages.every(isOkMessage)) {
    toast.success("Done");
    return;
  }

  if (typeof data === "string") {
    toast[status](data);
  } else if (Array.isArray(data?.messages)) {
    data.messages.map((e: string) => {
      if (isOkMessage(e)) {
        toast.success("Done");
        return;
      }
      return toast[status](e);
    });
  } else if (data?.message) {
    toast[status](data.message);
  } else if (status === "success") {
    toast.success("Done");
  } else {
    toast.error("Something went wrong");
  }
};
